<template>
  <v-expansion-panels v-if="evidencias.length" accordion flat>
    <v-expansion-panel>
      <v-expansion-panel-header class="body-2 font-weight-medium pt-0 px-0" :class="classeCabecalho">
        Evidências ({{ evidencias.length }})
      </v-expansion-panel-header>
      <v-expansion-panel-content class="px-0">
        <v-list dense>
          <v-list-item v-for="evidencia in evidencias" :key="evidencia.id" class="px-0">
            <v-list-item-icon class="mr-3 mt-3">
              <v-icon color="primary">{{ icone }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ evidencia.titulo }}</v-list-item-title>
              <v-list-item-subtitle v-if="evidencia.subtitulo">{{ evidencia.subtitulo }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                :aria-label="`Remover ${evidencia.titulo}`"
                color="primary"
                icon
                small
                @click="$emit('remover', evidencia.id)"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  export default {
    name: 'EvidenciasSelecionadas',

    props: {
      evidencias: {
        type: Array,
        default: () => []
      },
      icone: {
        type: String,
        required: true
      },
      classeCabecalho: {
        type: String,
        default: ''
      }
    }
  };
</script>
